import { LabelConfig, LabelConfigRepository } from '@telespot/domain';
import { ParseBaseRepository } from '../../parse-base.repository';
import { LabelConfigTopology, ParseLabelConfigMapper } from './parse-label-config.mapper';
import { MethodTypeTopology } from './parse-method-type.mapper';

export class ParseLabelConfigRepository extends ParseBaseRepository implements LabelConfigRepository {
  private readonly mapper = new ParseLabelConfigMapper(this.parse);

  public async save(labelConfig: LabelConfig): Promise<LabelConfig> {
    const result = await this.mapper.fromDomain(labelConfig).save(null, this.options);

    return this.mapper.toDomain(result);
  }

  public async getById(id: string): Promise<LabelConfig | undefined> {
    try {
      const result = await new this.parse.Query(LabelConfigTopology.TABLE).get(id, this.options);

      return this.mapper.toDomain(result);
    } catch (error) {
      if (error instanceof this.parse.Error && error.code === this.parse.Error.OBJECT_NOT_FOUND) {
        return undefined;
      }
      throw error;
    }
  }

  public async findByMethodTypeAndLabel(methodTypeId: string, label: string): Promise<LabelConfig[]> {
    const methodType = this.subclasses.getSubclass(MethodTypeTopology.TABLE).createWithoutData(methodTypeId);

    const results = await new this.parse.Query(LabelConfigTopology.TABLE)
      .equalTo(LabelConfigTopology.METHOD_TYPE, methodType)
      .equalTo(LabelConfigTopology.LABEL, label)
      .find(this.options);

    return results.map((parseObject) => this.mapper.toDomain(parseObject));
  }

  public async findByLabel(label: string): Promise<LabelConfig[]> {
    const results = await new this.parse.Query(LabelConfigTopology.TABLE)
      .equalTo(LabelConfigTopology.LABEL, label)
      .find(this.options);

    return results.map((parseObject) => this.mapper.toDomain(parseObject));
  }

  public async findByMethodType(methodTypeId: string): Promise<LabelConfig[]> {
    const methodType = this.subclasses.getSubclass(MethodTypeTopology.TABLE).createWithoutData(methodTypeId);

    const results = await new this.parse.Query(LabelConfigTopology.TABLE)
      .equalTo(LabelConfigTopology.METHOD_TYPE, methodType)
      .find(this.options);

    return results.map((parseObject) => this.mapper.toDomain(parseObject));
  }
}
